<template>
    <div class="tip" :class="[classes]">
        <template v-if="content">
            <span class="tip-icon"
                  v-tippy="{ placement: 'top-start', arrow: true, arrowType : 'round', maxWidth: 250 }"
                  :content="content.replace(/\\n/g, '<br />')">
                {{ icon }}
            </span>
        </template>
        <template v-else>
            <slot name="html-tip"></slot>
        </template>
    </div>
</template>

<script>
    export default {
        name: "help-tip",
        props: {
            classes: String,
            icon: {
                type: String,
                default: "i"
            },
            html: {
                type: Boolean,
                default: false
            },
            content: {
                type: String,
                default: ""
            }
        }
    };
</script>
